import React from 'react';

import {
  Box,
  Button,
  Grid,
  styled
} from '@mui/material';
import {
  BaseModal,
  fields,
  Form
} from 'iron-forge-react-modules';

import { appFormUtil } from 'modules/layer00';
import { useForm } from 'react-hook-form';
import * as dataService from './dataService';
import * as types from './types';



const ContainerBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2)
}));

const ControlledTextField = fields.TextField.genControllerComponent<types.IFormState>();



export interface IProps {
  storeId?: string;
  onClose: () => void;
}

export const FC: React.FC<IProps> = props => {
  const form = useForm<types.IFormState>({
    defaultValues: {
      email: ''
    }
  });

  const [fnInviteUser, inviteUserTuple] = dataService.useInviteUser(props.storeId);



  const processSubmit = React.useCallback(
    async (data: types.IFormState) => {
      await fnInviteUser(appFormUtil.trimFormStateValues(data));
      props.onClose();
    },
    [
      fnInviteUser,
      props
    ]
  );

  const fnChildren = React.useCallback(
    () => (
      <Form.FC onSubmit={form.handleSubmit(processSubmit)}>
        <ContainerBox>
          <Grid container>
            <Grid
              item
              xs={12}>
              <ControlledTextField
                isRequired
                isDisabled={inviteUserTuple.loading}
                formControl={form.control}
                fieldKey="email"
                label="Email"
                type="email" />
            </Grid>

            <Grid
              item
              xs={12}>
              <Button
                disabled={inviteUserTuple.loading}
                type="submit">
                Invite User
              </Button>
            </Grid>
          </Grid>
        </ContainerBox>
      </Form.FC>
    ),
    [
      form,
      inviteUserTuple.loading,
      processSubmit
    ]
  );

  return (
    <BaseModal.FC
      isOpen
      onClose={props.onClose}>
      {fnChildren}
    </BaseModal.FC>
  );
};
